import { render, staticRenderFns } from "./BiometricOptInModal.vue?vue&type=template&id=1e9e315c&scoped=true"
import script from "./BiometricOptInModal.vue?vue&type=script&lang=js"
export * from "./BiometricOptInModal.vue?vue&type=script&lang=js"
import style0 from "./BiometricOptInModal.vue?vue&type=style&index=0&id=1e9e315c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9e315c",
  null
  
)

export default component.exports